export enum PlatformApplicationImportSource {
  CATCH_APPLY = 'catch-apply',
  FOLLOW_UP = 'follow-up',
}
